import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { onMounted, onUnmounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import { fetchDatasetDetails } from "@/api/datasets";
import {} from "@/api/jobs";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import { errorMessageAsString } from "@/utils/simple-error";
import { stateIsTerminal } from "@/utils/utils";
import DatasetStorage from "@/components/Dataset/DatasetStorage/DatasetStorage.vue";
import DatasetInformation from "@/components/DatasetInformation/DatasetInformation.vue";
import InheritanceChain from "@/components/InheritanceChain//InheritanceChain.vue";
import JobDependencies from "@/components/JobDependencies/JobDependencies.vue";
import JobDestinationParams from "@/components/JobDestinationParams/JobDestinationParams.vue";
import JobInformation from "@/components/JobInformation/JobInformation.vue";
import JobMetrics from "@/components/JobMetrics/JobMetrics.vue";
import JobParameters from "@/components/JobParameters/JobParameters.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetDetails',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        const { config, isConfigLoaded } = useConfig(true);
        const userStore = useUserStore();
        const { currentUser } = storeToRefs(userStore);
        const loading = ref(false);
        const jobTimeOut = ref(null);
        const jobDetails = ref();
        const dataset = ref(null);
        const jobLoadingError = ref(null);
        const datasetLoadingError = ref(null);
        async function getDatasetDetails() {
            loading.value = true;
            try {
                const data = await fetchDatasetDetails({ id: props.datasetId });
                dataset.value = data;
            }
            catch (e) {
                datasetLoadingError.value = errorMessageAsString(e) || "Unable to fetch available dataset details.";
            }
            finally {
                loading.value = false;
            }
        }
        async function loadJobDetails() {
            const { data, error } = await GalaxyApi().GET("/api/jobs/{job_id}", {
                params: {
                    path: { job_id: dataset.value?.creating_job },
                    query: { full: true },
                },
            });
            if (error) {
                jobLoadingError.value = errorMessageAsString(error);
                return;
            }
            if (stateIsTerminal(data)) {
                clearTimeout(jobTimeOut.value);
            }
            else {
                jobTimeOut.value = setTimeout(loadJobDetails, 3000);
            }
            jobDetails.value = data;
        }
        onMounted(async () => {
            await getDatasetDetails();
            const creatingJobId = dataset.value?.creating_job;
            if (creatingJobId) {
                await loadJobDetails();
            }
        });
        onUnmounted(() => {
            clearTimeout(jobTimeOut.value);
        });
        return { __sfc: true, props, config, isConfigLoaded, userStore, currentUser, loading, jobTimeOut, jobDetails, dataset, jobLoadingError, datasetLoadingError, getDatasetDetails, loadJobDetails, BAlert, DatasetStorage, DatasetInformation, InheritanceChain, JobDependencies, JobDestinationParams, JobInformation, JobMetrics, JobParameters, LoadingSpan };
    }
});
